import { useMemo } from "react";
import { useGomakeTheme } from "@/hooks/use-gomake-thme";

const useStyle = ({
  withCircle,
  isHpClient = false,
}: {
  withCircle: boolean;
  isHpClient?: boolean;
}) => {
  const { primaryColor, theme } = useGomakeTheme();
  const classes = useMemo(() => {
    const noCircle = isHpClient || !withCircle;
    return {
      button: {
        border: noCircle ? "none" : "1px solid",
        color: primaryColor(500),
        height: isHpClient ? 24 : withCircle ? 22 : 25,
        width: isHpClient ? 24 : withCircle ? 22 : 25,
        ...(isHpClient && {
          minWidth: 24,
          minHeight: 24,
          padding: 2,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "8px",
          color: "#1A1A1A",
          "& svg": { display: "block" },
          "& path": { fill: "#1A1A1A" },
          "&:hover": {
            backgroundColor: "#8585851A",
          },
          "&.Mui-selected, &:active": {
            backgroundColor: "#85858533",
          },
        }),
      },
      menuItem: isHpClient
        ? {
            sx: {
              display: "flex",
              flexDirection: "column",
              alignItems: "stretch",
              // width: "var(--theme-combobox-min-width, 200px)",
              minWidth: "var(--theme-combobox-min-width, 200px)",
              maxHeight: "var(--theme-combobox-max-height, 332px)",
              padding: "var(--theme-combobox-items-padding, 8px)",
              gap: "var(--theme-combobox-items-gap, 4px)",
              justifyContent: "flex-start",
              backgroundColor: "var(--theme-combobox-bg, #FFFFFF)",
              boxShadow:
                "var(--theme-combobox-shadow, 0px 4px 16px 4px rgba(26, 26, 26, 0.2))",
              borderRadius: "var(--theme-combobox-radius, 12px)",
              color: "var(--theme-combobox-label-color, #1A1A1A)",
              "& .MuiList-root": {
                padding: 0,
                gap: "var(--theme-combobox-items-gap, 4px)",
                display: "flex",
                flexDirection: "column",
              },
            },
          }
        : {
            display: "flex",
            width: 125,
            justifyContent: "space-between",
            alignItems: "center",
            color: primaryColor(300),
          },
      iconStyle: {
        width: isHpClient ? 24 : withCircle ? 14 : 18,
        height: isHpClient ? 24 : withCircle ? 14 : 18,
        ...(isHpClient && { color: "#1A1A1A", "& path": { fill: "#1A1A1A" } }),
      },
    };
  }, [theme, withCircle, isHpClient]);
  return {
    classes,
  };
};
export { useStyle };
